/**
 * @file
 * Keep in sync with widget/src/app/utils/copy.tsx
 * until we figure out code-sharing solution!
 */
import React from 'react';

export const getDefaultCopy = () => ({
  IDLE_HELP_TEXT: 'Talk to a<br />live agent',
  IDLE_HELP_TEXT_FOCUSED: 'Start a<br />call now',
  IDLE_BUSY_TEXT: 'Book a<br />meeting',
  IDLE_BUSY_TEXT_FOCUSED: `We're busy<br />right now`,
  IDLE_AWAY_TEXT: 'Book a<br />meeting',
  IDLE_AWAY_TEXT_FOCUSED: `We're gone<br />right now`,
  ANSWER_CALL: "I'd like to join your session and speak with you",
  NEED_HELP_TITLE: 'Talk to an expert now',
  NEED_HELP_TEXT: 'We’re happy to help! Hit the button below to connect to a live agent.',
  NEED_HELP_TITLE_OFFLINE: "We're offline",
  NEED_HELP_TEXT_OFFLINE:
    "Our agents are away, but send us a message and we'll get back to you.",
  NEED_HELP_AWAY_TEXT:
    "Our agents are away, but send us a message and we'll get back to you.",
  NEED_HELP_AWAY_TITLE: "We're offline",
  NEED_HELP_BUSY_TEXT:
    "Our agents are away, but send us a message and we'll get back to you.",
  NEED_HELP_BUSY_TITLE: "We're offline",
  NEED_HELP_CTA: 'Start call',
  DIALING_TITLE: "We're on<br />our way",
  RECORDING_OPTIN_TITLE: 'Allow agent to record?',
  RECORDING_OPTIN_TEXT: 'An agent is requesting permission to begin recording.',
});

const brRegex = /<br\s?\/?>/g;
const lbRegex = /(\r\n|\r|\n)/g;

/**
 * Takes in string copy and returns a React node meant for rendering.
 */
export const renderCopy = (copy: string) => {
  const pieces = copy.split(brRegex).map((item, idx) => (
    <React.Fragment key={idx}>
      {idx !== 0 && <br />}
      {item.trim()}
    </React.Fragment>
  ));
  return <>{pieces}</>;
};

/**
 * Takes in html and converts <br /> linebreaks to textarea \r\n.
 */
export const convertFromHtml = (copy: string | null) => {
  if (!copy) return '';
  return copy.replace(brRegex, '\r\n');
};

/**
 * Takes in textarea string and converts \r\n linebreaks to html <br />.
 */
export const convertToHtml = (copy: string | null) => {
  if (!copy) return copy;
  return copy.replace(lbRegex, '<br />');
};
